import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {filter, map, switchMap, withLatestFrom} from 'rxjs/operators';
import * as userPaymentsActions from "../actions/payments.action";
import {DbResponse} from "../../shared/interceptors/db-response";
import {WorkspaceService} from "../../workspace/workspace.service";
import {clientRoles} from "../../user/user-roles-actions";
import {EMPTY} from "rxjs/internal/observable/empty";
import {Store} from "@ngrx/store";
import * as fromStore from "../index";

@Injectable()
export class UserPaymentsEffect {

  loadUserPayments$ = createEffect(() => this._actions$.pipe(
    ofType(userPaymentsActions.LOAD_USER_PAYMENTS),
    withLatestFrom(this._store.select(fromStore.getUserSubscription)),
    switchMap(([action, userSubscription]) => {
      if ([clientRoles.SUITE_DEV].includes(+localStorage.getItem('dbCurrentWorkspaceRoleId'))) {
        // Only fetch payments if subscription is not non-billable
        if (userSubscription && userSubscription.is_non_billable === false) {
          return this._workspaceService.getPayments()
            .pipe(
              filter((response: DbResponse) => !!response),
              map((response: DbResponse) => {
                if (response.success) {
                  return new userPaymentsActions.LoadUserPaymentsSuccess(response.data);
                }
                return new userPaymentsActions.LoadUserPaymentsFail(response.message);
              })
            );
        }
        return EMPTY;
      }
      else return EMPTY;
    })
  ));

  constructor(
    private _actions$: Actions,
    private _workspaceService: WorkspaceService,
    private _store: Store<fromStore.DbStoreState>,
  ) {
  }

}
